import { useEffect, useRef } from 'react';

/**
 * Custom hook for date input fields to handle the date-filled class
 * This ensures empty date fields appear lighter (opacity 0.4) and filled ones appear normal (opacity 1)
 * 
 * Usage:
 * const dateInputRef = useDateInput(formData.date_field);
 * <Input type="date" ref={dateInputRef} value={formData.date_field} ... />
 */
export const useDateInput = (value) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      if (value) {
        inputRef.current.classList.add('date-filled');
      } else {
        inputRef.current.classList.remove('date-filled');
      }
    }
  }, [value]);

  return inputRef;
};

export default useDateInput;
